/**
 * Action types
 * @property {string} EMAIL_OPT_IN
 * @property {string} EMAIL_OPT_OUT
 */
export const types = {
  EMAIL_OPT_IN: "EMAIL_OPT_IN",
  EMAIL_OPT_OUT: "EMAIL_OPT_OUT",
};

/**
 * @namespace Reducers
 */
export const reducers = {
  /**
   * Updates email opt-in state
   * @param {object} state
   * @param {object} action
   * @param {string} action.type
   */
  emailOptIn: (state = true, action) => {
    switch (action.type) {
      case types.EMAIL_OPT_IN:
        return true;
      case types.EMAIL_OPT_OUT:
        return false;
      default:
        return state;
    }
  },
};

/**
 * @namespace Actions
 */
export const actions = {
  handleOptIn: optedIn => ({
    type: optedIn ? types.EMAIL_OPT_IN : types.EMAIL_OPT_OUT,
  }),
};
